// Industries served by the firm. Distinct from Practice Areas — an
// industry is a client sector, whereas a practice area is a legal service.
//
// The firm's practice areas apply across industries. This list highlights
// the sectors where the firm has the deepest client experience.

export const INDUSTRIES = [
  {
    slug: "space",
    number: "01",
    name: "Space",
    kicker: "Counsel for launch, satellite, ground-segment, and space-services companies.",
    lead:
      "Commercial space is one of the most heavily regulated environments in which a modern business can operate — the practice sits at the intersection of export controls, FCC licensing, spectrum policy, foreign investment, and traditional corporate law. The firm represents companies across the launch, satellite, ground-segment, in-space services, and space-adjacent-technology segments.",
    relatedPracticeAreas: ["export-compliance", "fcc", "cfius", "foci", "international-trade"],
  },
  {
    slug: "defense",
    number: "02",
    name: "Defense",
    kicker: "Counsel for companies contracting with the Department of Defense and defense-adjacent primes.",
    lead:
      "Defense clients face a stack of regulatory obligations — FAR/DFARS, cybersecurity flow-downs, export controls, foreign investment review, and industrial security requirements — that most commercial companies never encounter. The firm advises companies pursuing DoD contracts, defense subcontractors, and dual-use technology companies operating at the commercial-defense boundary.",
    relatedPracticeAreas: ["government-contracts", "foci", "export-compliance", "cfius", "international-trade"],
  },
  {
    slug: "ai",
    number: "03",
    name: "Artificial Intelligence",
    kicker: "Counsel for AI developers, deployers, and enterprise buyers.",
    lead:
      "AI companies operate at the intersection of intellectual property, export controls (foundation models, compute, weights), commercial licensing, and an emerging patchwork of federal and state AI regulation. The firm advises AI developers, foundation-model users, downstream deployers, and enterprise buyers evaluating AI vendor risk.",
    // Existing content lives at /services/artificial-intelligence
    legacyServicesSlug: "artificial-intelligence",
    relatedPracticeAreas: ["intellectual-property", "export-compliance", "business-transactions"],
  },
  {
    slug: "semiconductor",
    number: "04",
    name: "Semiconductor",
    kicker: "Counsel for the fabless, EDA, IP, equipment, and advanced-packaging ecosystem.",
    lead:
      "The semiconductor industry sits at the center of U.S. export control policy, CFIUS scrutiny, and industrial-policy programs (CHIPS Act). The firm advises fabless companies, EDA and IP vendors, equipment manufacturers, advanced-packaging startups, and investors across the value chain.",
    legacyServicesSlug: "semiconductor-industry",
    relatedPracticeAreas: ["export-compliance", "cfius", "international-trade", "intellectual-property"],
  },
];

export function getIndustry(slug) {
  return INDUSTRIES.find((i) => i.slug === slug);
}

// Reverse lookup: given a practice-area slug, return the industries that
// list it under relatedPracticeAreas.
export function getIndustriesForPracticeArea(practiceAreaSlug) {
  return INDUSTRIES.filter(
    (i) => Array.isArray(i.relatedPracticeAreas) && i.relatedPracticeAreas.includes(practiceAreaSlug)
  );
}
